function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function Minimise({
  title,
  titleId,
  ...props
}) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: props.size || 16,
    height: props.size || 16,
    viewBox: "0 0 24 24",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M9.927 13.081h.032l.052.004-.084-.004c.052 0 .104.004.155.012l.035.007a.818.818 0 01.095.022l.011.004c.03.009.06.02.088.031l.033.015c.025.01.05.024.074.037l.028.017a.887.887 0 01.076.051l.017.014.003.001.01.008c.059.047.112.1.158.16l-.076-.086c.04.04.075.081.106.125l.031.046a.999.999 0 01.012.02l.014.023a.92.92 0 01.04.078l.013.032a.86.86 0 01.028.073l.013.044a.795.795 0 01.032.177 1.212 1.212 0 01.004.089v6.473a1 1 0 11-2 0l-.001-4.059-6.22 6.22a.997.997 0 01-1.413 0 .999.999 0 010-1.414l6.22-6.22h-4.06a1 1 0 010-2h6.474zM22.748 1.293a1 1 0 010 1.414l-6.22 6.22h4.059a1 1 0 110 2h-6.472c-.04 0-.08-.003-.12-.007l-.008-.001-.018-.003a.994.994 0 01-.22-.058l-.038-.016a.614.614 0 01-.036-.017l-.03-.015a.993.993 0 01-.385-.363l-.016-.028a.91.91 0 01-.04-.079l-.012-.027a.854.854 0 01-.019-.049l-.011-.033a.996.996 0 01-.032-.128l-.005-.028a1.003 1.003 0 01-.01-.131v-6.49a1 1 0 112 0v4.058l6.219-6.22a1 1 0 011.414 0z",
    fill: props.color || "#222",
    fillRule: "evenodd"
  }));
}

const MemoMinimise = React.memo(Minimise);
export default MemoMinimise;